// 引入封装好的request
import request from "@/utills/request";

// 详情
export const apppage = (data) => {
  return request({
    url: 'bankPage/getInfo',
    method: 'POST',
    data: data
  })
}
export const login = (data) => {
  return request({
    url: 'api/tokens/supplier',
    method: 'POST',
    data: data
  })
}
// 材料分类
export const datadict = (type) => {
  return request({
    url: 'api/v1/datadict/' + type,
    method: 'GET',
  })
}
// 刷新token
export const refreshToken = (data) => {
  return request({
    url: 'api/tokens/supplier/refresh',
    method: 'POST',
    data: data
  })
}
// 获取所有门店
export const storeList = () => {
  return request({
    url: 'api/department/getalldepartment',
    method: 'GET',
  })
}
// 预约
export const CustomerAppointment = (data) => {
  return request({
    url: 'api/appoint/submit',
    method: 'POST',
    data: data
  })
}
// 在建工地列表
export const constructionSite = () => {
  return request({
    url: 'api/constructionsite/getconstructionsite',
    method: 'GET',
  })
}
// 工地预约
export const SiteAppointment = (data) => {
  return request({
    url: 'api/constructionsite/appoint',
    method: 'POST',
    data: data
  })
}
// 装修类型(微装列表)
export const MicroInstallationList = () => {
  return request({
    url: 'api/v1/microsolution/genres',
    method: 'GET',
  })
}
// 装修类型(整装列表)
export const PackageList = (type) => {
  return request({
    url: 'api/v1/fullsolution/list/scope/' + type,
    method: 'GET',
  })
}
// 装修类型(软装列表)
export const SoftDecorationList = () => {
  return request({
    url: 'api/v1/softwaresolution/template/styles',
    method: 'GET',
  })
}
export const materialTypeList = () => {
  return request({
    url: 'api/v1/goods/getgoodstypes',
    method: 'GET',
  })
}
// 商品列表
export const commodityList = (data) => {
  return request({
    // url:'api/v1/material/supplier/pagelist',
    url: 'api/v1/goods/getgoodslist',
    method: 'POST',
    data: data
  })
}
// 商品详情
export const ProductDetails = (id) => {
  return request({
    url: 'api/v1/material/' + id,
    method: 'GET',
  })
}

// 商品下单支付
export const placeorderpayment = (data) => {
  return request({
    url: 'api/v1/goods/placeorderpayment',
    method: 'POST',
    data: data
  })
}
// 根据工地名称获取摩看工地
export const getprojectbyname = (name) => {
  return request({
    url: 'api/constructionsite/getprojectbyname?name=' + name,
    method: 'GET',
  })
}

// 预约(普通预约+工地预约)
export const reservationNew = (data) => {
  return request({
    url: 'api/user/insertcustomer',
    method: 'POST',
    data: data
  })
}
// 订单信息
export const OrderingInformationByTel = (phone) => {
  return request({
    url: 'api/v1/goods/getorderinfo?phone=' + phone,
    method: 'GET',
  })
}
// 门店登录
export const storeLogin = (data) => {
  return request({
    url: 'api/tokens',
    method: 'POST',
    data: data
  })
}
// 门店登录
export const getCustomersCount = (data) => {
  return request({
    url: 'api/constructionsite/getsigncount',
    method: 'POST',
    data: data
  })
}
// 内部员工token刷新
export const userTokenRefresh = (data) => {
  return request({
    url: 'api/tokens/refresh',
    method: 'POST',
    data: data
  })
}

// 在建工地列表
export const constructionSitePage = (pageIndex, pageSize) => {
  return request({
    url: 'api/constructionsite/getprojectpage?pageIndex=' + pageIndex + '&pageSize=' + pageSize,
    method: 'GET',
  })
}

// 大屏监控列表
export const monitorList = () => {
  return request({
    url: 'api/constructionsite/getrealtimescreen',
    method: 'GET',
  })
}
// 工地总数
export const workSite = (data) => {
  return request({
    url: 'api/constructionsite/getconstructionsitecount',
    method: 'POST',
    data: data
  })
}
// 工地列表
export const constructionSiteApi = (pageIndex, pageSize) => {
  return request({
    url: 'api/constructionsite/mokan/page?pageIndex=' + pageIndex + '&pageSize=' + pageSize,
    method: 'GET',
  })
}
// 根据工地名称获取摩看工地
export const getMonitorApi = (id) => {
  return request({
    url: 'api/constructionsite/mokan/live?deviceId=' + id,
    method: 'GET',
  })
}
